export default function createLoanStatusBadgeColor(status) {
  switch (status) {
    case 'active':
      return 'emerald';
    case 'review':
      return 'amber';
    case 'archived':
    case 'paid':
      return 'blue';
    case 'pending':
      return 'indigo';
    default:
      return 'indigo';
  }
}
